// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query SupplierQuery($id: ID!)  {\nsupplier(id: $id)  {\n__typename  \nid  \ncompanyName  \nemail  \nphoneNumber  \nmobileNumber  \ncontacts  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nisDefault  \ncivility  \nlastName  \nfirstName  \nemail  \nphoneNumber  \nmobileNumber  \n}\n\n}\n\n}\n\nlocations  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nrecipient  \naddress  \npostalCode  \ncity  \ncountry  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.supplier;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.email;
    let value$3 = value$1.phoneNumber;
    let value$4 = value$1.mobileNumber;
    let value$5 = value$1.contacts;
    let value$6 = value$5.edges;
    let value$7 = value$1.locations;
    let value$8 = value$7.edges;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      companyName: value$1.companyName,
      email: !(value$2 == null) ? value$2 : undefined,
      phoneNumber: !(value$3 == null) ? value$3 : undefined,
      mobileNumber: !(value$4 == null) ? value$4 : undefined,
      contacts: {
        __typename: value$5.__typename,
        edges: value$6.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.civility;
          let tmp;
          if (value$2 == null) {
            tmp = undefined;
          } else {
            let tmp$1;
            switch (value$2) {
              case "MR" :
                tmp$1 = "MR";
                break;
              case "MRS" :
                tmp$1 = "MRS";
                break;
              case "NEUTRAL" :
                tmp$1 = "NEUTRAL";
                break;
              default:
                throw {
                  RE_EXN_ID: "Not_found",
                  Error: new Error()
                };
            }
            tmp = tmp$1;
          }
          let value$3 = value$1.firstName;
          let value$4 = value$1.email;
          let value$5 = value$1.phoneNumber;
          let value$6 = value$1.mobileNumber;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              isDefault: value$1.isDefault,
              civility: tmp,
              lastName: value$1.lastName,
              firstName: !(value$3 == null) ? value$3 : undefined,
              email: !(value$4 == null) ? value$4 : undefined,
              phoneNumber: !(value$5 == null) ? value$5 : undefined,
              mobileNumber: !(value$6 == null) ? value$6 : undefined
            }
          };
        })
      },
      locations: {
        __typename: value$7.__typename,
        edges: value$8.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.recipient;
          let value$3 = value$1.address;
          let value$4 = value$1.postalCode;
          let value$5 = value$1.city;
          let value$6 = value$1.country;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              recipient: !(value$2 == null) ? value$2 : undefined,
              address: !(value$3 == null) ? value$3 : undefined,
              postalCode: !(value$4 == null) ? value$4 : undefined,
              city: !(value$5 == null) ? value$5 : undefined,
              country: !(value$6 == null) ? value$6 : undefined
            }
          };
        })
      }
    };
  }
  return {
    supplier: tmp
  };
}

function serialize(value) {
  let value$1 = value.supplier;
  let supplier;
  if (value$1 !== undefined) {
    let value$2 = value$1.locations;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.country;
      let country = value$2 !== undefined ? value$2 : null;
      let value$3 = value$1.city;
      let city = value$3 !== undefined ? value$3 : null;
      let value$4 = value$1.postalCode;
      let postalCode = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.address;
      let address = value$5 !== undefined ? value$5 : null;
      let value$6 = value$1.recipient;
      let recipient = value$6 !== undefined ? value$6 : null;
      let value$7 = value$1.__typename;
      let node = {
        __typename: value$7,
        recipient: recipient,
        address: address,
        postalCode: postalCode,
        city: city,
        country: country
      };
      let value$8 = value.__typename;
      return {
        __typename: value$8,
        node: node
      };
    });
    let value$4 = value$2.__typename;
    let locations = {
      __typename: value$4,
      edges: edges
    };
    let value$5 = value$1.contacts;
    let value$6 = value$5.edges;
    let edges$1 = value$6.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.mobileNumber;
      let mobileNumber = value$2 !== undefined ? value$2 : null;
      let value$3 = value$1.phoneNumber;
      let phoneNumber = value$3 !== undefined ? value$3 : null;
      let value$4 = value$1.email;
      let email = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.firstName;
      let firstName = value$5 !== undefined ? value$5 : null;
      let value$6 = value$1.lastName;
      let value$7 = value$1.civility;
      let civility = value$7 !== undefined ? (
          value$7 === "MR" ? "MR" : (
              value$7 === "MRS" ? "MRS" : "NEUTRAL"
            )
        ) : null;
      let value$8 = value$1.isDefault;
      let value$9 = value$1.__typename;
      let node = {
        __typename: value$9,
        isDefault: value$8,
        civility: civility,
        lastName: value$6,
        firstName: firstName,
        email: email,
        phoneNumber: phoneNumber,
        mobileNumber: mobileNumber
      };
      let value$10 = value.__typename;
      return {
        __typename: value$10,
        node: node
      };
    });
    let value$7 = value$5.__typename;
    let contacts = {
      __typename: value$7,
      edges: edges$1
    };
    let value$8 = value$1.mobileNumber;
    let mobileNumber = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.phoneNumber;
    let phoneNumber = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.email;
    let email = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.companyName;
    let value$12 = value$1.id;
    let value$13 = value$1.__typename;
    supplier = {
      __typename: value$13,
      id: value$12,
      companyName: value$11,
      email: email,
      phoneNumber: phoneNumber,
      mobileNumber: mobileNumber,
      contacts: contacts,
      locations: locations
    };
  } else {
    supplier = null;
  }
  return {
    supplier: supplier
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let SupplierQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let SupplierQuery_refetchQueryDescription = include.refetchQueryDescription;

let SupplierQuery_use = include.use;

let SupplierQuery_useLazy = include.useLazy;

let SupplierQuery_useLazyWithVariables = include.useLazyWithVariables;

let SupplierQuery = {
  SupplierQuery_inner: SupplierQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: SupplierQuery_refetchQueryDescription,
  use: SupplierQuery_use,
  useLazy: SupplierQuery_useLazy,
  useLazyWithVariables: SupplierQuery_useLazyWithVariables
};

export {
  SupplierQuery,
}
/* query Not a pure module */
